// This is a generated file that will be overwritten

// --- types

export interface ServerResponse {
    OK: boolean;
    Code: number;
    Error: string;
    Errors?: ValidationError[];
    AuthToken?: string;
}

export interface ValidationError {
    Parameter: string;
    Error: string;
}

export interface Accounting {
    ID: string;
    CourseProviderID: string;
    CourseProviderName: string;
    InvoiceState: string;
    InvoiceDate: object;
    Appointments: number;
    Bookings: number;
    Sum: number;
    CommissionSum: number;
    Month: string;
    CourseBookings: CourseBookings[];
    UpdateDate: object;
    InsertDate: object;
    CourseProviderCommission: number;
    CourseProviderVat: string;
}

export interface AccountingListParamsResult {
    Lines: Accounting[];
    Count: number;
}

export interface AccountingLoadMineResult {
    Accounted: Accounting;
    Bookings: Accounting;
}

export interface Appointment {
    StartDate: object;
    EndDate: object;
    MaxParticipants: number;
    Dates: object[];
}

export interface BasedataEntry {
    Content: string;
    ID: number;
}

export interface BasedataEntryParams {
    Content: string;
    ID: number;
}

export interface BasedataParams {
    Data: BasedataEntryParams[];
    Name: string;
    Key: string;
}

export interface Booking {
    ID: string;
    CourseID: string;
    CourseName: string;
    CourseProviderID: string;
    CourseProviderName: string;
    BookingOptionName: string;
    BookingOptionPrice: number;
    Commission: number;
    CommissionFee: number;
    Appointment: object;
    Lecturer: string;
    State: string;
    FirstName: string;
    LastName: string;
    Email: string;
    Telephone: string;
    Street: string;
    City: string;
    Zip: string;
    Note: string;
    Rejected: boolean;
    Reason: string;
    OriginalPrice?: number;
    OriginalCommissionFee?: number;
    UpdateDate: object;
    InsertDate: object;
}

export interface BookingListLine {
    BookingID: string;
    CourseProviderName: string;
    CourseName: string;
    Lecturer: string;
    BookingsDate: string;
    CourseDate: string;
    BookingOptionName: string;
    BookingOptionPrice: number;
    Provision: number;
    FirstName: string;
    LastName: string;
    City: string;
    Street: string;
    Zip: string;
    Telephone: string;
    Note: string;
    Rejected: boolean;
    Reason: string;
    Email: string;
}

export interface BookingOption {
    Name: string;
    Price: number;
    Default: boolean;
}

export interface BookingsListResult {
    Lines: BookingListLine[];
    Count: number;
}

export interface Course {
    ID: string;
    CourseProviderID: string;
    CourseProviderName: string;
    Title: string;
    Slug?: string;
    RefNo: string;
    Description: string;
    TimeDetails: string;
    MaterialDetails: string;
    AccomodationDetails: string;
    CateringDetails: string;
    LocationID: number;
    LecturerID: number;
    LecturerName: string;
    Images: Image[];
    VideoURL: string;
    Categories: number[];
    Techniques: number[];
    Topics: number[];
    Levels: number[];
    Tags: number[];
    Type: string;
    Appointments: Appointment[];
    BookingOptions: BookingOption[];
    Published: boolean;
    Disabled: boolean;
    Deleted?: boolean;
    NeedsSync?: boolean;
    SyncDate?: object;
    SyncError?: string;
    PublicUrl: string;
    StartTime: object;
    EndTime: object;
    UpdateDate: object;
    InsertDate: object;
}

export interface CourseBookings {
    CourseID: string;
    CourseName: string;
    CourseDate: object;
    Bookings: Booking[];
}

export interface CourseListLine {
    CourseID: string;
    CourseProviderName: string;
    CourseProviderID: string;
    Email: string;
    Title: string;
    Lecturer: string;
    Type: string;
    BookingOptions: BookingOption[];
    Appointments: CoursesListAppointmentLine[];
    PublicUrl: string;
    Published: boolean;
    Disabled: boolean;
    InsertDate: object;
}

export interface CourseProvider {
    ID: string;
    UserID: string;
    Name: string;
    Slug?: string;
    Referral: boolean;
    ContactingFromWhere: string;
    ContactPersonSalutation: string;
    ContactPersonFirstName: string;
    ContactPersonLastName: string;
    CompanyName: string;
    Telephone: string;
    Street: string;
    City: string;
    Zip: string;
    Email: string;
    Country: string;
    Website: string;
    Description: string;
    ActivateUntil: object;
    BookingTerms: string;
    Vat: string;
    InvoiceAddress: boolean;
    InvoiceCompany: string;
    InvoiceFirstName: string;
    InvoiceLastName: string;
    InvoiceStreet: string;
    InvoiceCity: string;
    InvoiceZip: string;
    InvoiceCountry: string;
    FastbillID: string;
    ProfileImage?: Image;
    Categories: number[];
    Techniques: number[];
    Topics: number[];
    AcceptedTerms: string;
    AcceptedPrivacy: string;
    Locations: Location[];
    Lecturers: Lecturer[];
    Commission: number;
    Disabled: boolean;
    PublicUrl: string;
    Imported: boolean;
    IsDeleted: boolean;
    NeedsSync?: boolean;
    SyncDate?: object;
    SyncError?: string;
    UpdateDate: object;
    InsertDate: object;
}

export interface CourseProviderData {
    ProfileImage?: Image;
    AcceptedPrivacy: boolean;
    Commission: number;
    PublicUrl: string;
    Published?: boolean;
    Disabled: boolean;
    Imported: boolean;
    NeedsSync?: boolean;
    SyncDate?: object;
    SyncError?: string;
}

export interface CourseProviderEdit {
    Name: string;
    Referral: boolean;
    ContactingFromWhere: string;
    ContactPersonSalutation: string;
    ContactPersonFirstName: string;
    ContactPersonLastName: string;
    CompanyName: string;
    Telephone: string;
    Street: string;
    City: string;
    Zip: string;
    Email: string;
    Country: string;
    Website: string;
    Description: string;
    BookingTerms: string;
    Vat: string;
    InvoiceAddress: boolean;
    InvoiceCompany: string;
    InvoiceFirstName: string;
    InvoiceLastName: string;
    InvoiceStreet: string;
    InvoiceCity: string;
    InvoiceZip: string;
    InvoiceCountry: string;
    Categories: number[];
    Techniques: number[];
    Topics: number[];
    Locations: Location[];
    Lecturers: Lecturer[];
    AcceptedTerms: string;
    UploadImage?: UploadImage;
}

export interface CourseProviderListLine {
    CourseProviderID: string;
    Name: string;
    Address: string;
    ActiveCourses: number;
    Commission: number;
    Status: string;
    Disabled: boolean;
    Deleted: boolean;
    PublicUrl: string;
    FastbillID: string;
    Email: string;
    InsertDate: string;
}

export interface CourseProviderListResult {
    Lines: CourseProviderListLine[];
    Count: number;
}

export interface CourseProvidersAutoSuggestResult {
    ID: string;
    Name: string;
}

export interface CoursesListAppointmentLine {
    Appointment: Appointment;
    Bookings: number;
}

export interface CoursesListLoadMineLine {
    CourseID: string;
    Title: string;
    Lecturer: string;
    BookingOptions: BookingOption[];
    Published: boolean;
    Disabled: boolean;
    Type: string;
    Appointments: CoursesListAppointmentLine[];
}

export interface CoursesListLoadMineResult {
    Lines: CoursesListLoadMineLine[];
    Count: number;
}

export interface CoursesListResult {
    Lines: CourseListLine[];
    Count: number;
}

export interface DashboardBookingListEntry {
    DaysAgo: string;
    Course: string;
    CourseProvider: string;
    BookedDate: object;
    Name: string;
    Fee: string;
}

export interface DashboardCourseListEntry {
    DaysAgo: string;
    Title: string;
    CourseProviderName: string;
}

export interface DashboardCourseProviderListEntry {
    DaysAgo: string;
    Name: string;
    Percent: number;
}

export interface DashboardResult {
    Courses: DashboardCourseListEntry[];
    CourseProviders: DashboardCourseProviderListEntry[];
    Bookings: DashboardBookingListEntry[];
}

export interface Image {
    ID: string;
    ThumbnailURL: string;
    MediumURL: string;
    LargeURL: string;
}

export interface Lecturer {
    ID: number;
    Salutation: string;
    Title: string;
    FirstName: string;
    LastName: string;
    Description: string;
    ProfileURL: string;
    Image?: Image;
}

export interface Location {
    ID: number;
    Name: string;
    Slug?: string;
    Street: string;
    Zip: string;
    City: string;
    Country: string;
    Telephone: string;
    Lat: number;
    Long: number;
    Images: Image[];
    Particulatities: number[];
}

export interface ObjectIDParam {
    ID: string;
}

export interface SearchParams {
    Search: string;
    Sort: string;
    Descending: boolean;
    Offset: number;
    PageSize: number;
}

export interface UploadImage {
    ID?: string;
    FileName: string;
    ImageData: string;
    Delete: boolean;
}

export interface User {
    ID: string;
    Firstname: string;
    Lastname: string;
    Username: string;
    Gender: string;
    Role: string;
    Active: boolean;
    Deleted: boolean;
    Password: ArrayBuffer;
    UpdateDate: object;
    CreationDate: object;
    Token: string;
    ExpiresAt: object;
}

export interface UserData {
    Firstname: string;
    Lastname: string;
    Email: string;
    Gender: string;
}

export interface AccountingInvoicedParams {
    ID: string;
}

export interface AccountingListParams {
    Search: string;
    Sort: string;
    Descending: boolean;
    Offset: number;
    PageSize: number;
    CourseProviderId: string;
}

export interface AccountingLoadMineParams {
    Month: string;
}

export interface AccountingLoadParams {
    ID: string;
    Month: string;
}

export interface BaseDataTagsAutoSuggestListResult {
    TagsData: BasedataEntry[];
}

export interface BaseDataTagsAutoSuggestParameters {
    Search: string;
}

export interface BasedataListResult {
    Basedata: BasedataParams[];
}

export interface BasedataSaveParameters {
    Basedata: BasedataParams;
}

export interface BasedataSaveResult {
    Basedata: BasedataParams[];
}

export interface BookingChangeBoookingOptionParams {
    ID: string;
    BookingOption: BookingOption;
}

export interface BookingCreateItem {
    CourseId: string;
    CourseName: string;
    CourseProviderId: string;
    CourseProviderName: string;
    BookingOptionName: string;
    BookingOptionPrice: number;
    Appointment: object;
    FirstName: string;
    LastName: string;
    Lecturer: string;
    Email: string;
    Telephone: string;
    Street: string;
    City: string;
    Zip: string;
    Note: string;
}

export interface BookingCreateParams {
    Bookings: BookingCreateItem[];
    ManualEntry?: boolean;
}

export interface BookingCreateResult {
    Bookings: Booking[];
}

export interface BookingRejectParams {
    ID: string;
    Booking: Booking;
    Reason: string;
    NewPrice: number;
}

export interface BookingUnrejectParams {
    ID: string;
}

export interface BookingsListParams {
    Search: string;
    Sort: string;
    Descending: boolean;
    Offset: number;
    PageSize: number;
    StartDate: string;
    EndDate: string;
    CourseProviderId: string;
}

export interface CourseActivateParams {
    ID: string;
    EmailMessage: string;
}

export interface CourseDeactivateParams {
    ID: string;
    EmailMessage: string;
}

export interface CourseMinimal {
    ID: string;
    Title: string;
    Type: string;
    RefNo: string;
    Appointments: Appointment[];
    BookingOptions: BookingOption[];
}

export interface CourseNewResult {
    Course: Course;
}

export interface CourseProviderActivateParams {
    ID: string;
    EmailMessage: string;
}

export interface CourseProviderAutoSuggestListResult {
    CourseProviders: CourseProvidersAutoSuggestResult[];
}

export interface CourseProviderAutoSuggestParameters {
    Search: string;
}

export interface CourseProviderDeactivateParams {
    ID: string;
    EmailMessage: string;
}

export interface CourseProviderDeleteParameters {
    ID: string;
}

export interface CourseProviderEditCommissionParams {
    ID: string;
    Commission: number;
}

export interface CourseProviderEditFastBillParams {
    ID: string;
    FastBill: string;
}

export interface CourseProviderListParams {
    Search: string;
    Sort: string;
    Descending: boolean;
    Offset: number;
    PageSize: number;
}

export interface CourseSaveParams {
    ID: string;
    Course: Course;
    UploadImages?: UploadImage[];
}

export interface CoursesDeleteResult {
    HasBookings: boolean;
}

export interface CoursesListLoadMineParams {
    Search: string;
    Sort: string;
    Descending: boolean;
    Offset: number;
    PageSize: number;
    StartDate: string;
    EndDate: string;
}

export interface CoursesListParams {
    Search: string;
    Sort: string;
    Descending: boolean;
    Offset: number;
    PageSize: number;
    StartDate: string;
    EndDate: string;
    CourseProviderId: string;
}

export interface CoursesLoadMinimalResult {
    Courses: CourseMinimal[];
}

export interface CoursesProviderLoadMineResult {
    CourseProviderEdit: CourseProviderEdit;
    CourseProviderData: CourseProviderData;
    User: UserData;
}

export interface CoursesProviderRemoveLecturerParameters {
    EntryID: number;
}

export interface CoursesProviderRemoveLecturerResult {
    Lecturers: Lecturer[];
    MatchedList: string[];
}

export interface CoursesProviderRemoveLocationParameters {
    EntryID: number;
}

export interface CoursesProviderRemoveLocationResult {
    Locations: Location[];
    MatchedList: string[];
}

export interface CoursesProviderSaveLecturerParams {
    ID: number;
    Salutation: string;
    Title: string;
    FirstName: string;
    LastName: string;
    Description: string;
    ProfileURL: string;
    Image?: Image;
    UploadImage?: UploadImage;
}

export interface CoursesProviderSaveLecturerResult {
    Lecturers: Lecturer[];
}

export interface CoursesProviderSaveLocationParams {
    ID: number;
    Name: string;
    Street: string;
    Zip: string;
    City: string;
    Country: string;
    Telephone: string;
    Lat: number;
    Long: number;
    Images: Image[];
    UploadImages?: UploadImage[];
    Particulatities: number[];
}

export interface CoursesProviderSaveLocationResult {
    Locations: Location[];
}

export interface CreatePasswordResetTokenParameters {
    Email: string;
}

export interface LoginParameters {
    Username: string;
    Password: string;
}

export interface LoginResult {
    Token: string;
    Username: string;
    Role: string;
}

export interface PasswordResetParameters {
    Token: string;
    Password: string;
}

export interface RegisterParameters {
    Email: string;
    Salutation: string;
    FirstName: string;
    LastName: string;
    Name: string;
    Password: string;
    DataPrivacy: string;
    AcceptedTerms: string;
}

export interface RegistrationVerifyParameters {
    Token: string;
}

export interface UsersSavePasswordParams {
    Password: string;
}

export interface UsersSaveUsernameParams {
    Username: string;
}

export interface ValidatePasswordResetTokenParameters {
    Token: string;
}

export interface VerifySessionResult {
    User: User;
}

// --- api functions

let logAPIErrors: boolean = true;

export function enableAPIErrorLogging() {
    logAPIErrors = true;
}

export function ApiAccountingCloseMonth(result: (obj: ServerResponse & { Data?: Accounting }) => void) {
    const authToken: string = localStorage.getItem('authToken') || '';
    fetch('/api/accounting/closeMonth', { method: 'POST', headers: { auth: authToken }, credentials: 'same-origin' })
        .then((resp) => resp.json())
        .then((data) => {
            if (typeof data.AuthToken === 'string' && data.AuthToken.length > 0) {
                localStorage.setItem('authToken', data.AuthToken);
            }
            result(data);
        })
        .catch((err) => {
            if (logAPIErrors) {
                console.log(err);
            }
            result({ OK: false, Code: -1, Error: 'communication_error' });
        });
}

export function ApiAccountingInvoiced(
    params: AccountingInvoicedParams,
    result: (obj: ServerResponse & { Data?: Accounting }) => void
) {
    const authToken: string = localStorage.getItem('authToken') || '';
    fetch('/api/accounting/invoiced', {
        method: 'POST',
        body: JSON.stringify(params),
        headers: { auth: authToken },
        credentials: 'same-origin',
    })
        .then((resp) => resp.json())
        .then((data) => {
            if (typeof data.AuthToken === 'string' && data.AuthToken.length > 0) {
                localStorage.setItem('authToken', data.AuthToken);
            }
            result(data);
        })
        .catch((err) => {
            if (logAPIErrors) {
                console.log(err);
            }
            result({ OK: false, Code: -1, Error: 'communication_error' });
        });
}

export function ApiAccountingList(
    params: AccountingListParams,
    result: (obj: ServerResponse & { Data?: AccountingListParamsResult }) => void
) {
    const authToken: string = localStorage.getItem('authToken') || '';
    fetch('/api/accounting/list', {
        method: 'POST',
        body: JSON.stringify(params),
        headers: { auth: authToken },
        credentials: 'same-origin',
    })
        .then((resp) => resp.json())
        .then((data) => {
            if (typeof data.AuthToken === 'string' && data.AuthToken.length > 0) {
                localStorage.setItem('authToken', data.AuthToken);
            }
            result(data);
        })
        .catch((err) => {
            if (logAPIErrors) {
                console.log(err);
            }
            result({ OK: false, Code: -1, Error: 'communication_error' });
        });
}

export function ApiAccountingLoad(
    params: AccountingLoadParams,
    result: (obj: ServerResponse & { Data?: Accounting }) => void
) {
    const authToken: string = localStorage.getItem('authToken') || '';
    fetch('/api/accounting/load', {
        method: 'POST',
        body: JSON.stringify(params),
        headers: { auth: authToken },
        credentials: 'same-origin',
    })
        .then((resp) => resp.json())
        .then((data) => {
            if (typeof data.AuthToken === 'string' && data.AuthToken.length > 0) {
                localStorage.setItem('authToken', data.AuthToken);
            }
            result(data);
        })
        .catch((err) => {
            if (logAPIErrors) {
                console.log(err);
            }
            result({ OK: false, Code: -1, Error: 'communication_error' });
        });
}

export function ApiAccountingLoadmine(
    params: AccountingLoadMineParams,
    result: (obj: ServerResponse & { Data?: AccountingLoadMineResult }) => void
) {
    const authToken: string = localStorage.getItem('authToken') || '';
    fetch('/api/accounting/loadmine', {
        method: 'POST',
        body: JSON.stringify(params),
        headers: { auth: authToken },
        credentials: 'same-origin',
    })
        .then((resp) => resp.json())
        .then((data) => {
            if (typeof data.AuthToken === 'string' && data.AuthToken.length > 0) {
                localStorage.setItem('authToken', data.AuthToken);
            }
            result(data);
        })
        .catch((err) => {
            if (logAPIErrors) {
                console.log(err);
            }
            result({ OK: false, Code: -1, Error: 'communication_error' });
        });
}

export function ApiBasedataAutoSuggest(
    params: BaseDataTagsAutoSuggestParameters,
    result: (obj: ServerResponse & { Data?: BaseDataTagsAutoSuggestListResult }) => void
) {
    const authToken: string = localStorage.getItem('authToken') || '';
    fetch('/api/basedata/autoSuggest', {
        method: 'POST',
        body: JSON.stringify(params),
        headers: { auth: authToken },
        credentials: 'same-origin',
    })
        .then((resp) => resp.json())
        .then((data) => {
            if (typeof data.AuthToken === 'string' && data.AuthToken.length > 0) {
                localStorage.setItem('authToken', data.AuthToken);
            }
            result(data);
        })
        .catch((err) => {
            if (logAPIErrors) {
                console.log(err);
            }
            result({ OK: false, Code: -1, Error: 'communication_error' });
        });
}

export function ApiBasedataList(result: (obj: ServerResponse & { Data?: BasedataListResult }) => void) {
    const authToken: string = localStorage.getItem('authToken') || '';
    fetch('/api/basedata/list', { method: 'POST', headers: { auth: authToken }, credentials: 'same-origin' })
        .then((resp) => resp.json())
        .then((data) => {
            if (typeof data.AuthToken === 'string' && data.AuthToken.length > 0) {
                localStorage.setItem('authToken', data.AuthToken);
            }
            result(data);
        })
        .catch((err) => {
            if (logAPIErrors) {
                console.log(err);
            }
            result({ OK: false, Code: -1, Error: 'communication_error' });
        });
}

export function ApiBasedataSave(
    params: BasedataSaveParameters,
    result: (obj: ServerResponse & { Data?: BasedataSaveResult }) => void
) {
    const authToken: string = localStorage.getItem('authToken') || '';
    fetch('/api/basedata/save', {
        method: 'POST',
        body: JSON.stringify(params),
        headers: { auth: authToken },
        credentials: 'same-origin',
    })
        .then((resp) => resp.json())
        .then((data) => {
            if (typeof data.AuthToken === 'string' && data.AuthToken.length > 0) {
                localStorage.setItem('authToken', data.AuthToken);
            }
            result(data);
        })
        .catch((err) => {
            if (logAPIErrors) {
                console.log(err);
            }
            result({ OK: false, Code: -1, Error: 'communication_error' });
        });
}

export function ApiBookingsAdd(
    params: BookingCreateParams,
    result: (obj: ServerResponse & { Data?: BookingCreateResult }) => void
) {
    const authToken: string = localStorage.getItem('authToken') || '';
    fetch('/api/bookings/add', {
        method: 'POST',
        body: JSON.stringify(params),
        headers: { auth: authToken },
        credentials: 'same-origin',
    })
        .then((resp) => resp.json())
        .then((data) => {
            if (typeof data.AuthToken === 'string' && data.AuthToken.length > 0) {
                localStorage.setItem('authToken', data.AuthToken);
            }
            result(data);
        })
        .catch((err) => {
            if (logAPIErrors) {
                console.log(err);
            }
            result({ OK: false, Code: -1, Error: 'communication_error' });
        });
}

export function ApiBookingsChangeOption(
    params: BookingChangeBoookingOptionParams,
    result: (obj: ServerResponse & { Data?: Booking }) => void
) {
    const authToken: string = localStorage.getItem('authToken') || '';
    fetch('/api/bookings/changeOption', {
        method: 'POST',
        body: JSON.stringify(params),
        headers: { auth: authToken },
        credentials: 'same-origin',
    })
        .then((resp) => resp.json())
        .then((data) => {
            if (typeof data.AuthToken === 'string' && data.AuthToken.length > 0) {
                localStorage.setItem('authToken', data.AuthToken);
            }
            result(data);
        })
        .catch((err) => {
            if (logAPIErrors) {
                console.log(err);
            }
            result({ OK: false, Code: -1, Error: 'communication_error' });
        });
}

export function ApiBookingsCsv() {
    const authToken: string = localStorage.getItem('authToken') || '';
    let fileName = 'download.data';
    fetch('/api/bookings/csv', { method: 'POST', headers: { auth: authToken }, credentials: 'same-origin' })
        .then((resp) => {
            let str = resp.headers.get('Content-Disposition');
            if (str) {
                const startStr = 'filename="';
                let idx = str.indexOf(startStr);
                if (idx !== -1) {
                    str = str.substring(idx + startStr.length);
                    idx = str.indexOf('"');
                    if (idx !== -1) {
                        fileName = str.substring(0, idx);
                    }
                }
            }
            console.log();
            return resp.blob();
        })
        .then((blob) => {
            const a = document.createElement('a');
            a.href = URL.createObjectURL(blob);
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
        })
        .catch((err) => {
            if (logAPIErrors) {
                console.log(err);
            }
        });
}

export function ApiBookingsList(
    params: BookingsListParams,
    result: (obj: ServerResponse & { Data?: BookingsListResult }) => void
) {
    const authToken: string = localStorage.getItem('authToken') || '';
    fetch('/api/bookings/list', {
        method: 'POST',
        body: JSON.stringify(params),
        headers: { auth: authToken },
        credentials: 'same-origin',
    })
        .then((resp) => resp.json())
        .then((data) => {
            if (typeof data.AuthToken === 'string' && data.AuthToken.length > 0) {
                localStorage.setItem('authToken', data.AuthToken);
            }
            result(data);
        })
        .catch((err) => {
            if (logAPIErrors) {
                console.log(err);
            }
            result({ OK: false, Code: -1, Error: 'communication_error' });
        });
}

export function ApiBookingsReject(
    params: BookingRejectParams,
    result: (obj: ServerResponse & { Data?: Booking }) => void
) {
    const authToken: string = localStorage.getItem('authToken') || '';
    fetch('/api/bookings/reject', {
        method: 'POST',
        body: JSON.stringify(params),
        headers: { auth: authToken },
        credentials: 'same-origin',
    })
        .then((resp) => resp.json())
        .then((data) => {
            if (typeof data.AuthToken === 'string' && data.AuthToken.length > 0) {
                localStorage.setItem('authToken', data.AuthToken);
            }
            result(data);
        })
        .catch((err) => {
            if (logAPIErrors) {
                console.log(err);
            }
            result({ OK: false, Code: -1, Error: 'communication_error' });
        });
}

export function ApiBookingsUnreject(
    params: BookingUnrejectParams,
    result: (obj: ServerResponse & { Data?: Booking }) => void
) {
    const authToken: string = localStorage.getItem('authToken') || '';
    fetch('/api/bookings/unreject', {
        method: 'POST',
        body: JSON.stringify(params),
        headers: { auth: authToken },
        credentials: 'same-origin',
    })
        .then((resp) => resp.json())
        .then((data) => {
            if (typeof data.AuthToken === 'string' && data.AuthToken.length > 0) {
                localStorage.setItem('authToken', data.AuthToken);
            }
            result(data);
        })
        .catch((err) => {
            if (logAPIErrors) {
                console.log(err);
            }
            result({ OK: false, Code: -1, Error: 'communication_error' });
        });
}

export function ApiCourseActivate(
    params: CourseActivateParams,
    result: (obj: ServerResponse & { Data?: Course }) => void
) {
    const authToken: string = localStorage.getItem('authToken') || '';
    fetch('/api/course/activate', {
        method: 'POST',
        body: JSON.stringify(params),
        headers: { auth: authToken },
        credentials: 'same-origin',
    })
        .then((resp) => resp.json())
        .then((data) => {
            if (typeof data.AuthToken === 'string' && data.AuthToken.length > 0) {
                localStorage.setItem('authToken', data.AuthToken);
            }
            result(data);
        })
        .catch((err) => {
            if (logAPIErrors) {
                console.log(err);
            }
            result({ OK: false, Code: -1, Error: 'communication_error' });
        });
}

export function ApiCourseCsv() {
    const authToken: string = localStorage.getItem('authToken') || '';
    let fileName = 'download.data';
    fetch('/api/course/csv', { method: 'POST', headers: { auth: authToken }, credentials: 'same-origin' })
        .then((resp) => {
            let str = resp.headers.get('Content-Disposition');
            if (str) {
                const startStr = 'filename="';
                let idx = str.indexOf(startStr);
                if (idx !== -1) {
                    str = str.substring(idx + startStr.length);
                    idx = str.indexOf('"');
                    if (idx !== -1) {
                        fileName = str.substring(0, idx);
                    }
                }
            }
            console.log();
            return resp.blob();
        })
        .then((blob) => {
            const a = document.createElement('a');
            a.href = URL.createObjectURL(blob);
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
        })
        .catch((err) => {
            if (logAPIErrors) {
                console.log(err);
            }
        });
}

export function ApiCourseDeactivate(
    params: CourseDeactivateParams,
    result: (obj: ServerResponse & { Data?: Course }) => void
) {
    const authToken: string = localStorage.getItem('authToken') || '';
    fetch('/api/course/deactivate', {
        method: 'POST',
        body: JSON.stringify(params),
        headers: { auth: authToken },
        credentials: 'same-origin',
    })
        .then((resp) => resp.json())
        .then((data) => {
            if (typeof data.AuthToken === 'string' && data.AuthToken.length > 0) {
                localStorage.setItem('authToken', data.AuthToken);
            }
            result(data);
        })
        .catch((err) => {
            if (logAPIErrors) {
                console.log(err);
            }
            result({ OK: false, Code: -1, Error: 'communication_error' });
        });
}

export function ApiCourseDelete(
    params: ObjectIDParam,
    result: (obj: ServerResponse & { Data?: CoursesDeleteResult }) => void
) {
    const authToken: string = localStorage.getItem('authToken') || '';
    fetch('/api/course/delete', {
        method: 'POST',
        body: JSON.stringify(params),
        headers: { auth: authToken },
        credentials: 'same-origin',
    })
        .then((resp) => resp.json())
        .then((data) => {
            if (typeof data.AuthToken === 'string' && data.AuthToken.length > 0) {
                localStorage.setItem('authToken', data.AuthToken);
            }
            result(data);
        })
        .catch((err) => {
            if (logAPIErrors) {
                console.log(err);
            }
            result({ OK: false, Code: -1, Error: 'communication_error' });
        });
}

export function ApiCourseDuplicate(params: ObjectIDParam, result: (obj: ServerResponse) => void) {
    const authToken: string = localStorage.getItem('authToken') || '';
    fetch('/api/course/duplicate', {
        method: 'POST',
        body: JSON.stringify(params),
        headers: { auth: authToken },
        credentials: 'same-origin',
    })
        .then((resp) => resp.json())
        .then((data) => {
            if (typeof data.AuthToken === 'string' && data.AuthToken.length > 0) {
                localStorage.setItem('authToken', data.AuthToken);
            }
            result(data);
        })
        .catch((err) => {
            if (logAPIErrors) {
                console.log(err);
            }
            result({ OK: false, Code: -1, Error: 'communication_error' });
        });
}

export function ApiCourseList(
    params: CoursesListParams,
    result: (obj: ServerResponse & { Data?: CoursesListResult }) => void
) {
    const authToken: string = localStorage.getItem('authToken') || '';
    fetch('/api/course/list', {
        method: 'POST',
        body: JSON.stringify(params),
        headers: { auth: authToken },
        credentials: 'same-origin',
    })
        .then((resp) => resp.json())
        .then((data) => {
            if (typeof data.AuthToken === 'string' && data.AuthToken.length > 0) {
                localStorage.setItem('authToken', data.AuthToken);
            }
            result(data);
        })
        .catch((err) => {
            if (logAPIErrors) {
                console.log(err);
            }
            result({ OK: false, Code: -1, Error: 'communication_error' });
        });
}

export function ApiCourseLoad(params: ObjectIDParam, result: (obj: ServerResponse & { Data?: Course }) => void) {
    const authToken: string = localStorage.getItem('authToken') || '';
    fetch('/api/course/load', {
        method: 'POST',
        body: JSON.stringify(params),
        headers: { auth: authToken },
        credentials: 'same-origin',
    })
        .then((resp) => resp.json())
        .then((data) => {
            if (typeof data.AuthToken === 'string' && data.AuthToken.length > 0) {
                localStorage.setItem('authToken', data.AuthToken);
            }
            result(data);
        })
        .catch((err) => {
            if (logAPIErrors) {
                console.log(err);
            }
            result({ OK: false, Code: -1, Error: 'communication_error' });
        });
}

export function ApiCourseLoadmine(
    params: CoursesListLoadMineParams,
    result: (obj: ServerResponse & { Data?: CoursesListLoadMineResult }) => void
) {
    const authToken: string = localStorage.getItem('authToken') || '';
    fetch('/api/course/loadmine', {
        method: 'POST',
        body: JSON.stringify(params),
        headers: { auth: authToken },
        credentials: 'same-origin',
    })
        .then((resp) => resp.json())
        .then((data) => {
            if (typeof data.AuthToken === 'string' && data.AuthToken.length > 0) {
                localStorage.setItem('authToken', data.AuthToken);
            }
            result(data);
        })
        .catch((err) => {
            if (logAPIErrors) {
                console.log(err);
            }
            result({ OK: false, Code: -1, Error: 'communication_error' });
        });
}

export function ApiCourseLoadminimal(result: (obj: ServerResponse & { Data?: CoursesLoadMinimalResult }) => void) {
    const authToken: string = localStorage.getItem('authToken') || '';
    fetch('/api/course/loadminimal', { method: 'POST', headers: { auth: authToken }, credentials: 'same-origin' })
        .then((resp) => resp.json())
        .then((data) => {
            if (typeof data.AuthToken === 'string' && data.AuthToken.length > 0) {
                localStorage.setItem('authToken', data.AuthToken);
            }
            result(data);
        })
        .catch((err) => {
            if (logAPIErrors) {
                console.log(err);
            }
            result({ OK: false, Code: -1, Error: 'communication_error' });
        });
}

export function ApiCourseNew(result: (obj: ServerResponse & { Data?: CourseNewResult }) => void) {
    const authToken: string = localStorage.getItem('authToken') || '';
    fetch('/api/course/new', { method: 'POST', headers: { auth: authToken }, credentials: 'same-origin' })
        .then((resp) => resp.json())
        .then((data) => {
            if (typeof data.AuthToken === 'string' && data.AuthToken.length > 0) {
                localStorage.setItem('authToken', data.AuthToken);
            }
            result(data);
        })
        .catch((err) => {
            if (logAPIErrors) {
                console.log(err);
            }
            result({ OK: false, Code: -1, Error: 'communication_error' });
        });
}

export function ApiCourseSave(params: CourseSaveParams, result: (obj: ServerResponse) => void) {
    const authToken: string = localStorage.getItem('authToken') || '';
    fetch('/api/course/save', {
        method: 'POST',
        body: JSON.stringify(params),
        headers: { auth: authToken },
        credentials: 'same-origin',
    })
        .then((resp) => resp.json())
        .then((data) => {
            if (typeof data.AuthToken === 'string' && data.AuthToken.length > 0) {
                localStorage.setItem('authToken', data.AuthToken);
            }
            result(data);
        })
        .catch((err) => {
            if (logAPIErrors) {
                console.log(err);
            }
            result({ OK: false, Code: -1, Error: 'communication_error' });
        });
}

export function ApiCourseProvidersActivate(
    params: CourseProviderActivateParams,
    result: (obj: ServerResponse & { Data?: CourseProvider }) => void
) {
    const authToken: string = localStorage.getItem('authToken') || '';
    fetch('/api/courseProviders/activate', {
        method: 'POST',
        body: JSON.stringify(params),
        headers: { auth: authToken },
        credentials: 'same-origin',
    })
        .then((resp) => resp.json())
        .then((data) => {
            if (typeof data.AuthToken === 'string' && data.AuthToken.length > 0) {
                localStorage.setItem('authToken', data.AuthToken);
            }
            result(data);
        })
        .catch((err) => {
            if (logAPIErrors) {
                console.log(err);
            }
            result({ OK: false, Code: -1, Error: 'communication_error' });
        });
}

export function ApiCourseProvidersAutoSuggest(
    params: CourseProviderAutoSuggestParameters,
    result: (obj: ServerResponse & { Data?: CourseProviderAutoSuggestListResult }) => void
) {
    const authToken: string = localStorage.getItem('authToken') || '';
    fetch('/api/courseProviders/autoSuggest', {
        method: 'POST',
        body: JSON.stringify(params),
        headers: { auth: authToken },
        credentials: 'same-origin',
    })
        .then((resp) => resp.json())
        .then((data) => {
            if (typeof data.AuthToken === 'string' && data.AuthToken.length > 0) {
                localStorage.setItem('authToken', data.AuthToken);
            }
            result(data);
        })
        .catch((err) => {
            if (logAPIErrors) {
                console.log(err);
            }
            result({ OK: false, Code: -1, Error: 'communication_error' });
        });
}

export function ApiCourseProvidersCommission(
    params: CourseProviderEditCommissionParams,
    result: (obj: ServerResponse) => void
) {
    const authToken: string = localStorage.getItem('authToken') || '';
    fetch('/api/courseProviders/commission', {
        method: 'POST',
        body: JSON.stringify(params),
        headers: { auth: authToken },
        credentials: 'same-origin',
    })
        .then((resp) => resp.json())
        .then((data) => {
            if (typeof data.AuthToken === 'string' && data.AuthToken.length > 0) {
                localStorage.setItem('authToken', data.AuthToken);
            }
            result(data);
        })
        .catch((err) => {
            if (logAPIErrors) {
                console.log(err);
            }
            result({ OK: false, Code: -1, Error: 'communication_error' });
        });
}

export function ApiCourseProvidersCsv() {
    const authToken: string = localStorage.getItem('authToken') || '';
    let fileName = 'download.data';
    fetch('/api/courseProviders/csv', { method: 'POST', headers: { auth: authToken }, credentials: 'same-origin' })
        .then((resp) => {
            let str = resp.headers.get('Content-Disposition');
            if (str) {
                const startStr = 'filename="';
                let idx = str.indexOf(startStr);
                if (idx !== -1) {
                    str = str.substring(idx + startStr.length);
                    idx = str.indexOf('"');
                    if (idx !== -1) {
                        fileName = str.substring(0, idx);
                    }
                }
            }
            console.log();
            return resp.blob();
        })
        .then((blob) => {
            const a = document.createElement('a');
            a.href = URL.createObjectURL(blob);
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
        })
        .catch((err) => {
            if (logAPIErrors) {
                console.log(err);
            }
        });
}

export function ApiCourseProvidersDeactivate(
    params: CourseProviderDeactivateParams,
    result: (obj: ServerResponse & { Data?: CourseProvider }) => void
) {
    const authToken: string = localStorage.getItem('authToken') || '';
    fetch('/api/courseProviders/deactivate', {
        method: 'POST',
        body: JSON.stringify(params),
        headers: { auth: authToken },
        credentials: 'same-origin',
    })
        .then((resp) => resp.json())
        .then((data) => {
            if (typeof data.AuthToken === 'string' && data.AuthToken.length > 0) {
                localStorage.setItem('authToken', data.AuthToken);
            }
            result(data);
        })
        .catch((err) => {
            if (logAPIErrors) {
                console.log(err);
            }
            result({ OK: false, Code: -1, Error: 'communication_error' });
        });
}

export function ApiCourseProvidersDelete(
    params: CourseProviderDeleteParameters,
    result: (obj: ServerResponse) => void
) {
    const authToken: string = localStorage.getItem('authToken') || '';
    fetch('/api/courseProviders/delete', {
        method: 'POST',
        body: JSON.stringify(params),
        headers: { auth: authToken },
        credentials: 'same-origin',
    })
        .then((resp) => resp.json())
        .then((data) => {
            if (typeof data.AuthToken === 'string' && data.AuthToken.length > 0) {
                localStorage.setItem('authToken', data.AuthToken);
            }
            result(data);
        })
        .catch((err) => {
            if (logAPIErrors) {
                console.log(err);
            }
            result({ OK: false, Code: -1, Error: 'communication_error' });
        });
}

export function ApiCourseProvidersFastbill(
    params: CourseProviderEditFastBillParams,
    result: (obj: ServerResponse) => void
) {
    const authToken: string = localStorage.getItem('authToken') || '';
    fetch('/api/courseProviders/fastbill', {
        method: 'POST',
        body: JSON.stringify(params),
        headers: { auth: authToken },
        credentials: 'same-origin',
    })
        .then((resp) => resp.json())
        .then((data) => {
            if (typeof data.AuthToken === 'string' && data.AuthToken.length > 0) {
                localStorage.setItem('authToken', data.AuthToken);
            }
            result(data);
        })
        .catch((err) => {
            if (logAPIErrors) {
                console.log(err);
            }
            result({ OK: false, Code: -1, Error: 'communication_error' });
        });
}

export function ApiCourseProvidersImageUpload(
    params: UploadImage,
    result: (obj: ServerResponse & { Data?: Image }) => void
) {
    const authToken: string = localStorage.getItem('authToken') || '';
    fetch('/api/courseProviders/image/upload', {
        method: 'POST',
        body: JSON.stringify(params),
        headers: { auth: authToken },
        credentials: 'same-origin',
    })
        .then((resp) => resp.json())
        .then((data) => {
            if (typeof data.AuthToken === 'string' && data.AuthToken.length > 0) {
                localStorage.setItem('authToken', data.AuthToken);
            }
            result(data);
        })
        .catch((err) => {
            if (logAPIErrors) {
                console.log(err);
            }
            result({ OK: false, Code: -1, Error: 'communication_error' });
        });
}

export function ApiCourseProvidersList(
    params: CourseProviderListParams,
    result: (obj: ServerResponse & { Data?: CourseProviderListResult }) => void
) {
    const authToken: string = localStorage.getItem('authToken') || '';
    fetch('/api/courseProviders/list', {
        method: 'POST',
        body: JSON.stringify(params),
        headers: { auth: authToken },
        credentials: 'same-origin',
    })
        .then((resp) => resp.json())
        .then((data) => {
            if (typeof data.AuthToken === 'string' && data.AuthToken.length > 0) {
                localStorage.setItem('authToken', data.AuthToken);
            }
            result(data);
        })
        .catch((err) => {
            if (logAPIErrors) {
                console.log(err);
            }
            result({ OK: false, Code: -1, Error: 'communication_error' });
        });
}

export function ApiCourseProvidersLoadmine(
    result: (obj: ServerResponse & { Data?: CoursesProviderLoadMineResult }) => void
) {
    const authToken: string = localStorage.getItem('authToken') || '';
    fetch('/api/courseProviders/loadmine', { method: 'POST', headers: { auth: authToken }, credentials: 'same-origin' })
        .then((resp) => resp.json())
        .then((data) => {
            if (typeof data.AuthToken === 'string' && data.AuthToken.length > 0) {
                localStorage.setItem('authToken', data.AuthToken);
            }
            result(data);
        })
        .catch((err) => {
            if (logAPIErrors) {
                console.log(err);
            }
            result({ OK: false, Code: -1, Error: 'communication_error' });
        });
}

export function ApiCourseProvidersRemoveLecturer(
    params: CoursesProviderRemoveLecturerParameters,
    result: (obj: ServerResponse & { Data?: CoursesProviderRemoveLecturerResult }) => void
) {
    const authToken: string = localStorage.getItem('authToken') || '';
    fetch('/api/courseProviders/removeLecturer', {
        method: 'POST',
        body: JSON.stringify(params),
        headers: { auth: authToken },
        credentials: 'same-origin',
    })
        .then((resp) => resp.json())
        .then((data) => {
            if (typeof data.AuthToken === 'string' && data.AuthToken.length > 0) {
                localStorage.setItem('authToken', data.AuthToken);
            }
            result(data);
        })
        .catch((err) => {
            if (logAPIErrors) {
                console.log(err);
            }
            result({ OK: false, Code: -1, Error: 'communication_error' });
        });
}

export function ApiCourseProvidersRemoveLocation(
    params: CoursesProviderRemoveLocationParameters,
    result: (obj: ServerResponse & { Data?: CoursesProviderRemoveLocationResult }) => void
) {
    const authToken: string = localStorage.getItem('authToken') || '';
    fetch('/api/courseProviders/removeLocation', {
        method: 'POST',
        body: JSON.stringify(params),
        headers: { auth: authToken },
        credentials: 'same-origin',
    })
        .then((resp) => resp.json())
        .then((data) => {
            if (typeof data.AuthToken === 'string' && data.AuthToken.length > 0) {
                localStorage.setItem('authToken', data.AuthToken);
            }
            result(data);
        })
        .catch((err) => {
            if (logAPIErrors) {
                console.log(err);
            }
            result({ OK: false, Code: -1, Error: 'communication_error' });
        });
}

export function ApiCourseProvidersSaveLecturer(
    params: CoursesProviderSaveLecturerParams,
    result: (obj: ServerResponse & { Data?: CoursesProviderSaveLecturerResult }) => void
) {
    const authToken: string = localStorage.getItem('authToken') || '';
    fetch('/api/courseProviders/saveLecturer', {
        method: 'POST',
        body: JSON.stringify(params),
        headers: { auth: authToken },
        credentials: 'same-origin',
    })
        .then((resp) => resp.json())
        .then((data) => {
            if (typeof data.AuthToken === 'string' && data.AuthToken.length > 0) {
                localStorage.setItem('authToken', data.AuthToken);
            }
            result(data);
        })
        .catch((err) => {
            if (logAPIErrors) {
                console.log(err);
            }
            result({ OK: false, Code: -1, Error: 'communication_error' });
        });
}

export function ApiCourseProvidersSaveLocation(
    params: CoursesProviderSaveLocationParams,
    result: (obj: ServerResponse & { Data?: CoursesProviderSaveLocationResult }) => void
) {
    const authToken: string = localStorage.getItem('authToken') || '';
    fetch('/api/courseProviders/saveLocation', {
        method: 'POST',
        body: JSON.stringify(params),
        headers: { auth: authToken },
        credentials: 'same-origin',
    })
        .then((resp) => resp.json())
        .then((data) => {
            if (typeof data.AuthToken === 'string' && data.AuthToken.length > 0) {
                localStorage.setItem('authToken', data.AuthToken);
            }
            result(data);
        })
        .catch((err) => {
            if (logAPIErrors) {
                console.log(err);
            }
            result({ OK: false, Code: -1, Error: 'communication_error' });
        });
}

export function ApiCourseProvidersSavemine(
    params: CourseProviderEdit,
    result: (obj: ServerResponse & { Data?: CoursesProviderLoadMineResult }) => void
) {
    const authToken: string = localStorage.getItem('authToken') || '';
    fetch('/api/courseProviders/savemine', {
        method: 'POST',
        body: JSON.stringify(params),
        headers: { auth: authToken },
        credentials: 'same-origin',
    })
        .then((resp) => resp.json())
        .then((data) => {
            if (typeof data.AuthToken === 'string' && data.AuthToken.length > 0) {
                localStorage.setItem('authToken', data.AuthToken);
            }
            result(data);
        })
        .catch((err) => {
            if (logAPIErrors) {
                console.log(err);
            }
            result({ OK: false, Code: -1, Error: 'communication_error' });
        });
}

export function ApiDashboardLoad(result: (obj: ServerResponse & { Data?: DashboardResult }) => void) {
    const authToken: string = localStorage.getItem('authToken') || '';
    fetch('/api/dashboard/load', { method: 'POST', headers: { auth: authToken }, credentials: 'same-origin' })
        .then((resp) => resp.json())
        .then((data) => {
            if (typeof data.AuthToken === 'string' && data.AuthToken.length > 0) {
                localStorage.setItem('authToken', data.AuthToken);
            }
            result(data);
        })
        .catch((err) => {
            if (logAPIErrors) {
                console.log(err);
            }
            result({ OK: false, Code: -1, Error: 'communication_error' });
        });
}

export function ApiLogin(params: LoginParameters, result: (obj: ServerResponse & { Data?: LoginResult }) => void) {
    const authToken: string = localStorage.getItem('authToken') || '';
    fetch('/api/login', {
        method: 'POST',
        body: JSON.stringify(params),
        headers: { auth: authToken },
        credentials: 'same-origin',
    })
        .then((resp) => resp.json())
        .then((data) => {
            if (typeof data.AuthToken === 'string' && data.AuthToken.length > 0) {
                localStorage.setItem('authToken', data.AuthToken);
            }
            result(data);
        })
        .catch((err) => {
            if (logAPIErrors) {
                console.log(err);
            }
            result({ OK: false, Code: -1, Error: 'communication_error' });
        });
}

export function ApiLogout(result: (obj: ServerResponse) => void) {
    const authToken: string = localStorage.getItem('authToken') || '';
    fetch('/api/logout', { method: 'POST', headers: { auth: authToken }, credentials: 'same-origin' })
        .then((resp) => resp.json())
        .then((data) => {
            if (typeof data.AuthToken === 'string' && data.AuthToken.length > 0) {
                localStorage.setItem('authToken', data.AuthToken);
            }
            result(data);
        })
        .catch((err) => {
            if (logAPIErrors) {
                console.log(err);
            }
            result({ OK: false, Code: -1, Error: 'communication_error' });
        });
}

export function ApiPasswordRequest(params: CreatePasswordResetTokenParameters, result: (obj: ServerResponse) => void) {
    const authToken: string = localStorage.getItem('authToken') || '';
    fetch('/api/password/request', {
        method: 'POST',
        body: JSON.stringify(params),
        headers: { auth: authToken },
        credentials: 'same-origin',
    })
        .then((resp) => resp.json())
        .then((data) => {
            if (typeof data.AuthToken === 'string' && data.AuthToken.length > 0) {
                localStorage.setItem('authToken', data.AuthToken);
            }
            result(data);
        })
        .catch((err) => {
            if (logAPIErrors) {
                console.log(err);
            }
            result({ OK: false, Code: -1, Error: 'communication_error' });
        });
}

export function ApiPasswordReset(params: PasswordResetParameters, result: (obj: ServerResponse) => void) {
    const authToken: string = localStorage.getItem('authToken') || '';
    fetch('/api/password/reset', {
        method: 'POST',
        body: JSON.stringify(params),
        headers: { auth: authToken },
        credentials: 'same-origin',
    })
        .then((resp) => resp.json())
        .then((data) => {
            if (typeof data.AuthToken === 'string' && data.AuthToken.length > 0) {
                localStorage.setItem('authToken', data.AuthToken);
            }
            result(data);
        })
        .catch((err) => {
            if (logAPIErrors) {
                console.log(err);
            }
            result({ OK: false, Code: -1, Error: 'communication_error' });
        });
}

export function ApiPasswordValidate(
    params: ValidatePasswordResetTokenParameters,
    result: (obj: ServerResponse) => void
) {
    const authToken: string = localStorage.getItem('authToken') || '';
    fetch('/api/password/validate', {
        method: 'POST',
        body: JSON.stringify(params),
        headers: { auth: authToken },
        credentials: 'same-origin',
    })
        .then((resp) => resp.json())
        .then((data) => {
            if (typeof data.AuthToken === 'string' && data.AuthToken.length > 0) {
                localStorage.setItem('authToken', data.AuthToken);
            }
            result(data);
        })
        .catch((err) => {
            if (logAPIErrors) {
                console.log(err);
            }
            result({ OK: false, Code: -1, Error: 'communication_error' });
        });
}

export function ApiRegister(params: RegisterParameters, result: (obj: ServerResponse) => void) {
    const authToken: string = localStorage.getItem('authToken') || '';
    fetch('/api/register', {
        method: 'POST',
        body: JSON.stringify(params),
        headers: { auth: authToken },
        credentials: 'same-origin',
    })
        .then((resp) => resp.json())
        .then((data) => {
            if (typeof data.AuthToken === 'string' && data.AuthToken.length > 0) {
                localStorage.setItem('authToken', data.AuthToken);
            }
            result(data);
        })
        .catch((err) => {
            if (logAPIErrors) {
                console.log(err);
            }
            result({ OK: false, Code: -1, Error: 'communication_error' });
        });
}

export function ApiRegisterVerify(params: RegistrationVerifyParameters, result: (obj: ServerResponse) => void) {
    const authToken: string = localStorage.getItem('authToken') || '';
    fetch('/api/register/verify', {
        method: 'POST',
        body: JSON.stringify(params),
        headers: { auth: authToken },
        credentials: 'same-origin',
    })
        .then((resp) => resp.json())
        .then((data) => {
            if (typeof data.AuthToken === 'string' && data.AuthToken.length > 0) {
                localStorage.setItem('authToken', data.AuthToken);
            }
            result(data);
        })
        .catch((err) => {
            if (logAPIErrors) {
                console.log(err);
            }
            result({ OK: false, Code: -1, Error: 'communication_error' });
        });
}

export function ApiSession(result: (obj: ServerResponse & { Data?: VerifySessionResult }) => void) {
    const authToken: string = localStorage.getItem('authToken') || '';
    fetch('/api/session', { method: 'POST', headers: { auth: authToken }, credentials: 'same-origin' })
        .then((resp) => resp.json())
        .then((data) => {
            if (typeof data.AuthToken === 'string' && data.AuthToken.length > 0) {
                localStorage.setItem('authToken', data.AuthToken);
            }
            result(data);
        })
        .catch((err) => {
            if (logAPIErrors) {
                console.log(err);
            }
            result({ OK: false, Code: -1, Error: 'communication_error' });
        });
}

export function ApiUsersSavePassword(params: UsersSavePasswordParams, result: (obj: ServerResponse) => void) {
    const authToken: string = localStorage.getItem('authToken') || '';
    fetch('/api/users/savePassword', {
        method: 'POST',
        body: JSON.stringify(params),
        headers: { auth: authToken },
        credentials: 'same-origin',
    })
        .then((resp) => resp.json())
        .then((data) => {
            if (typeof data.AuthToken === 'string' && data.AuthToken.length > 0) {
                localStorage.setItem('authToken', data.AuthToken);
            }
            result(data);
        })
        .catch((err) => {
            if (logAPIErrors) {
                console.log(err);
            }
            result({ OK: false, Code: -1, Error: 'communication_error' });
        });
}

export function ApiUsersSaveUsername(params: UsersSaveUsernameParams, result: (obj: ServerResponse) => void) {
    const authToken: string = localStorage.getItem('authToken') || '';
    fetch('/api/users/saveUsername', {
        method: 'POST',
        body: JSON.stringify(params),
        headers: { auth: authToken },
        credentials: 'same-origin',
    })
        .then((resp) => resp.json())
        .then((data) => {
            if (typeof data.AuthToken === 'string' && data.AuthToken.length > 0) {
                localStorage.setItem('authToken', data.AuthToken);
            }
            result(data);
        })
        .catch((err) => {
            if (logAPIErrors) {
                console.log(err);
            }
            result({ OK: false, Code: -1, Error: 'communication_error' });
        });
}



// WEBPACK FOOTER //
// ./src/api.ts